import axios from 'axios'
import laroute from '~/laroute'
import store from '~/store'

// state
export const state = {
  companyProducts: [],
  productsTotal: 0,
  components: [],
  product: null,
  structure: [],

  noChargeReasons: []
}

// getters
export const getters = {
  companyProducts: state => state.companyProducts,
  productsTotal: state => state.productsTotal,
  noChargeReasons: state => state.noChargeReasons,
  components: state => state.components,
  product: state => state.product,
  structure: state => state.structure
}

// mutations
export const mutations = {
  SET_COMPANY_PRODUCTS (state, data) {
    state.companyProducts = data
  },
  SET_TOTAL (state, data) {
    state.total = data
  },
  SET_NO_CHARGE_REASONS (state, data) {
    state.noChargeReasons = data
  },
  COMPONENTS (state, data) {
    state.components = data
  },
  PRODUCT (state, data) {
    state.product = data
  },
  STRUCTURE (state, data) {
    state.structure = data
  }
}

// actions
export const actions = {
  async fetchCompanyProducts ({ commit }, value) {
    const allTypesExceptServicesAndFreight = [1, 2, 3, 4, 5, 6, 7, 8, 9, 11, 13]
    const response = await axios.get(`/api/${value.companyAbbr}/products/filter?sortBy=part_number&item_types=${allTypesExceptServicesAndFreight.join()}&rowsPerPage=200`)
    commit('SET_COMPANY_PRODUCTS', response.data.items)
    commit('SET_TOTAL', response.data.total)
  },
  async fetchNoChargeReasons ({ commit }) {
    const response = await axios.get('/api/no-charge-reason/list')
    commit('SET_NO_CHARGE_REASONS', response.data)
  },
  async getKitComponents ({ commit }, id) {
    const response = await axios.get(laroute.route('get_kit_components', {
      companyAbbr: store.getters['auth/company'],
      id: id
    }))
    commit('COMPONENTS', response.data)
  },

  async getProduct ({ commit }, id) {
    const response = await axios.get(laroute.route('get_product', {
      companyAbbr: store.getters['auth/company'],
      productId: id
    }))
    commit('PRODUCT', response.data)
  },

  async getStructure ({ commit }, workOrderId) {
    const response = await axios.get(laroute.route('get-product-structure', {
      companyAbbr: store.getters['auth/company'], workOrderId
    }))
    commit('STRUCTURE', response.data)
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/products.js